module.exports = __webpack_public_path__ + "static/media/bar-design.bff8cf05.png";